import { Button, Table } from 'antd';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { farmStore } from '@/stores';

export const FarmerFarmsTable = observer(
  ({ farmerId, onOpenFarm }: { farmerId: number; onOpenFarm: (farmId: number) => void }) => {
    useEffect(() => {
      if (farmerId) {
        farmStore.forceLoad({ farmerId, limit: 100 });
      }
    }, [farmerId]);

    const columns = useMemo(
      () => [
        {
          title: <FormattedMessage id="farms.farmId" />,
          dataIndex: 'farmId',
          key: 'farmId',
          width: 140,
          render: (_: unknown, record: cyrian.api.farms.Farm) => record.farmId?.trim() || '—',
        },
        {
          title: <FormattedMessage id="farms.product" />,
          dataIndex: 'product',
          key: 'product',
          width: 120,
        },
        {
          title: <FormattedMessage id="farms.village" />,
          dataIndex: 'village',
          key: 'village',
          width: 120,
        },
        {
          title: <FormattedMessage id="farms.district" />,
          dataIndex: 'district',
          key: 'district',
          width: 120,
        },
        {
          title: <FormattedMessage id="farms.region" />,
          dataIndex: 'region',
          key: 'region',
          width: 120,
        },
        {
          title: <FormattedMessage id="farms.plotsCount" />,
          dataIndex: 'plotsCount',
          key: 'plotsCount',
          width: 100,
        },
        {
          title: '',
          key: 'action',
          width: 100,
          render: (_: unknown, record: cyrian.api.farms.Farm) => (
            <Button type="link" size="small" onClick={() => onOpenFarm(record.id)}>
              <FormattedMessage id="farms.open" />
            </Button>
          ),
        },
      ],
      [onOpenFarm],
    );

    const items = farmStore.items.filter((f) => f.farmerId === farmerId);

    return (
      <Table
        rowKey="id"
        columns={columns}
        dataSource={[...items]}
        loading={farmStore.loading}
        pagination={false}
        scroll={{ x: 800 }}
        size="small"
      />
    );
  },
);
